"use strict";
// THIS FILE WAS AUTOGENERATED
var DataPointType = require("./DataPointType");
"use strict";
/**
 * Metric data single measurement.
 */
var DataPoint = /** @class */ (function () {
    function DataPoint() {
        this.kind = DataPointType.Measurement;
    }
    return DataPoint;
}());
module.exports = DataPoint;
//# sourceMappingURL=DataPoint.js.map